<template>
  <div>
    <v-tabs
        v-model="currentTab"
        :show-arrows="$vuetify.breakpoint.mobile"
    >
      <v-tabs-slider color="pink"></v-tabs-slider>

      <v-tab
          icons-and-text
          v-for="tab in tabs"
          :key="tab.id"
      >
        <v-icon left>{{tab.icon}}</v-icon>
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-card
        :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
        :elevation="$vuetify.breakpoint.mobile ? 1 : 2"
    >
      <v-card-text>
        <div v-if="!error">
          <BuyoutItemInfo
              v-if="tabs[currentTab].id === tabMap.items.id"
              :buyout="buyout"
              :buyout-item="buyoutItem"
              :loading="loading"
              :settings="settings"
          ></BuyoutItemInfo>

          <BuyoutPaymentInfoList
              v-else-if="tabs[currentTab].id === tabMap.paymentsInfo.id"
              :buyout="buyout"
              @openAdminMessages="openAdminMessages"
          ></BuyoutPaymentInfoList>

          <BuyoutPickupPointList
              v-else
              :buyout="buyout"
              @openAdminMessages="openAdminMessages"
          ></BuyoutPickupPointList>
        </div>

        <Info
            v-if="error"
            :error="error"
        ></Info>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BuyoutItemInfo from '@/components/BuyoutItemInfo'
import BuyoutPaymentInfoList from '@/components/BuyoutPaymentInfoList'
import BuyoutPickupPointList from '@/components/BuyoutPickupPointList'
import Info from '@/components/Info'
import {appStates, status} from '@/constants'
import {getBuyout, getBuyoutItem} from '@/services/mock'
import {windowOpen} from '@/services/vkApi'
import Statuses from '@/services/statuses'

const tabs = {
  items: {
    id: 0,
    title: 'Список заказов',
    icon: 'mdi-cart'
  },
  paymentsInfo: {
    id: 1,
    title: 'Способы оплаты',
    icon: 'mdi-currency-usd'
  },
  pickupPoints: {
    id: 2,
    title: 'Точки выдачи',
    icon: 'mdi-store'
  }
}
export default {
  name: 'BuyoutItem',
  components: {BuyoutPaymentInfoList, BuyoutPickupPointList, BuyoutItemInfo, Info},
  created: function () {
    this.askBuyout(this.$route.params.buyoutId, this.$route.params.sourceId);
    this.$client.get(this.$API.SOURCES.SETTINGS.COMMON, {params: {sourceId: this.$route.params.sourceId}})
      .then((rs) => this.settings = rs)
      .catch(err => {
        this.error = err
    });
  },
  data () {
    return {
      buyout: null,
      buyoutItem: null,
      currentTab: tabs.items.id,
      error: null,
      isDraft: false,
      isNeedPay: false,
      loading: true,
      tabs: [tabs.items],
      tabMap: tabs,
      settings: {
        isShowNumberOrder: true
      },
    }
  },
  methods: {
    askBuyout (id, sourceId) {
      if (id.startsWith('demo_')) {
        this.buyout = getBuyout(id)
        this.buyoutItem = getBuyoutItem(id)
        this._checkTabsVisibility()
      } else {
        Promise.all([
          this.$client.get(this.$API.BUYOUTS.ITEM, {params: {buyoutId: id, describePaymentInfo: true}}),
          this.$client.get(this.$API.BUYOUTS.BUYOUT_ITEM, {params: {buyoutId: id, invoices: true}}),
        ])
          .then(([buyoutRs, buyoutItemRs]) => {
            this.buyout = buyoutRs
            this.buyoutItem = buyoutItemRs
            if (this.buyout.status === Statuses.getStatuses().draft.id){
              this.isDraft = true
            } else {
              this._checkTabsVisibility()
            }
            this._fillOrdersInInvoices()
          })
          .catch(err => {
            if (err.code === 404) {
              this.$router.replace(appStates.sourceItemContent.path.replace(':sourceId', sourceId))
            } else {
              this.error = err
            }
          })
          .finally(() => this.loading = false)
      }
    },
    openAdminMessages () {
      windowOpen(this.$API.VK_PERSONAL_DIALOG_PREFIX + this.buyout.admin.id);
    },
    _checkTabsVisibility () {
      this.buyout.needPay = this.buyout.status !== Statuses.getStatuses().draft.id &&
        this.buyout.status !== Statuses.getStatuses().progress.id && this.buyout.status !== Statuses.getStatuses().stop.id
      if (this.buyout.needPay && this.buyoutItem.acquiringPaymentType !== 'onlyAcquiring') {
        this.tabs.push(tabs.paymentsInfo)
      }
      if (this.buyout.pickupPoints.length > 0) {
        this.tabs.push(tabs.pickupPoints)
      }
    },
    _fillOrdersInInvoices () {
      let map = {}
      let verified = true
      const NEW_KEY = status.payment.unpayed.id
      this.buyoutItem.orders.items.forEach(order => {
        verified = verified && order.verified
        order.photo = this.buyoutItem.orders.photos[order.photoId]
        order.wallPosts = this.buyoutItem.orders.wallPosts[order.wallPostId]
        order.tags = this.buyoutItem.tags
        let key = order.invoiceId || NEW_KEY
        if (!map[key]) map[key] = []
        map[key].push(order)
      });
      this.buyoutItem.verified = verified

      this.buyoutItem.invoices.forEach(invoice => {
        if (invoice.status === status.payment.unpayed.id) {
          invoice.orders = map[NEW_KEY]
        } else {
          invoice.orders = map[invoice.id]
        }
      });
    }
  }
}
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
.show {
  visibility: visible;
}
</style>